/*
    this hook is to scroll up to the top of 
    the  form window of a validation error happend 
*/

import { useEffect } from "react"
import { useSelector } from "react-redux"
import useModuleActions from "./useModuleActions"
import { useLocation } from "react-router-dom"
import useCustomNavigate from "./routerHooks/useCustomNavigate"

// pass in an array of errors
const useSecureURL = () => {
  const { navigateToReplace } = useCustomNavigate()
  const location = useLocation()
  const pageType = location.pathname.split("/")[2]

  const { module } = useSelector((state) => ({
    module: state.Module.actions,
  }))

  const {
    isBatchUploadPermission,
    isAddPermission,
    isUpdatePermission,
    isViewPermission,
  } = useModuleActions()
  useEffect(() => {
    if (module && pageType === "upload" && !isBatchUploadPermission) {
      navigateToReplace("/")
    } else if (module && pageType === "add" && !isAddPermission) {
      navigateToReplace("/")
    } else if (module && pageType === "edit" && !isUpdatePermission) {
      navigateToReplace("/")
    } else if (module && pageType === "view" && !isViewPermission) {
      navigateToReplace("/")
    }
  }, [module, pageType])
}

export default useSecureURL
